export default "__VITE_ASSET__f37b00ac__"